
import {Vue, Component, Prop} from "vue-property-decorator";
import {SystemModule, OrderModule} from "@/store/modules";
import {getModule} from "vuex-module-decorators";
import {AgentResource} from "@/models/api/system/agents";
import Select from "@/components/form/Select.vue";
import notifications from "@/lib/notifications";
import _ from "lodash";
import permissions from "@/security/permissions";

const systemModule = getModule(SystemModule);
const orderModule = getModule(OrderModule);

@Component(
  {
computed: { permissions() {
return permissions} } ,
    components: {
      Select
    }
  }
)

export default class ManageDeliveryTypes extends Vue {
  @Prop()
  agent: AgentResource;
  isModalVisible: boolean = false;
  newDeliveryType: any = {
    agentTypeCode: null,
    name: null,
    orderType: null,
    isActive: false,
    agentId: 0,
    typeCode: null
  }
  orderTypes: Array<any> = orderModule.orderTypes;
  agentDeliveryTypes: Array<any> = systemModule.agentDeliveryTypes;

  async editAgentDeliveryType(typeCode: string) {
    const foundItem = _.find(this.agentDeliveryTypes, (x) => {
      return x.typeCode === typeCode;
    });

    if(!foundItem) return;

    const orderTypeToSet = _.find(this.orderTypes, (x) => {
      return x.name === foundItem.orderType;
    });

    this.newDeliveryType.agentTypeCode = foundItem.typeCode;
    this.newDeliveryType.name = foundItem.name;
    this.newDeliveryType.orderType = orderTypeToSet.label;
    this.newDeliveryType.isActive = foundItem.isActive;
    this.newDeliveryType.agentId = this.agent.id
    this.newDeliveryType.typeCode = foundItem.typeCode;




    this.isModalVisible = true;
  }

  getOrderType(data) {
    const foundValue = _.find(this.orderTypes, (x) => {
      return x.name === data.item.orderType;
    });

    if(!foundValue) return "";
    return foundValue.label;
  }

  async created() {
    await systemModule.loadAgentDeliveryTypes(this.agent.id);
    this.agentDeliveryTypes = systemModule.agentDeliveryTypes;
  }

  async updateAgentDeliveryType() {

    const valueToSet = _.find(this.orderTypes, (x) => {
      return x.label === this.newDeliveryType.orderType;
    });

    if(valueToSet)
      this.newDeliveryType.orderType = valueToSet.name;

    try {
      await systemModule.updateAgentDeliveryType(this.newDeliveryType);
      notifications.success("Success", `Delivery Type saved.`);
    } catch (error) {
      notifications.error("Save Failed", "Unable to save delivery type.", error);
    } finally {
      await systemModule.loadAgentDeliveryTypes(this.agent.id);
      this.agentDeliveryTypes = systemModule.agentDeliveryTypes;
    }
  }

  async addDeliveryType() {
    if(this.newDeliveryType.typeCode) {
      await this.updateAgentDeliveryType();
      return;
    }

    try {
      this.newDeliveryType.agentId = this.agent.id;

      const orderType = _.find(this.orderTypes, (x) => {
        return x.label === this.newDeliveryType.orderType;
      });

      this.newDeliveryType.orderType = orderType.name;
      await systemModule.saveAgentDeliveryType(this.newDeliveryType)
      notifications.success("Success", `Delivery Type saved.`);
    } catch (error) {
      notifications.error("Save Failed", "Unable to save delivery type.", error);
    } finally {
      await systemModule.loadAgentDeliveryTypes(this.agent.id);
      this.agentDeliveryTypes = systemModule.agentDeliveryTypes;
    }
  }

  showModal() {
    this.newDeliveryType = {
      agentId: null,
      typeCode: null,
      agentTypeCode: null,
      orderType: null,
      isActive: false
    }
    this.isModalVisible = true;
  }
}
